import React from 'react';

export const Separator = () => {
  return (
    <div
      style={{
        height: 1,
        width: '100%',
        backgroundColor: '#D8DAE8',
        marginBottom: 16,
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/pages/Versions/Editor/Separator/index.tsx